var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.524 48.643C38.9248 48.643 48.167 39.4008 48.167 28C48.167 16.5991 38.9248 7.35693 27.524 7.35693C16.1232 7.35693 6.881 16.5991 6.881 28C6.881 39.4008 16.1232 48.643 27.524 48.643Z",
    fill: "#FF0449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4198 21.9644L20.6283 35.7558",
    stroke: "white",
    strokeWidth: 2.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4198 35.7558L20.6283 21.9644",
    stroke: "white",
    strokeWidth: 2.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/ErrorCircle.42bd530dba297d1bb4dc8ad81dfda4f7.svg";
export { ForwardRef as ReactComponent };